"use client";

import cnBind from "classnames/bind";
import Link from "next/link";

import { Logo } from "@/components/Logo/Logo";
import { PageHeadSync } from "@/components/PageHeadSync/PageHeadSync";
import { useAuth } from "@/shared/auth/AuthContext";

import type { PageLayoutProps } from "./types";

import styles from "./PartnerCabinetLayout.module.scss";

const cx = cnBind.bind(styles);

export function PartnerCabinetLayout({ children, title, description }: PageLayoutProps) {
    const { logout, user } = useAuth();
    const siteUrl = process.env.NEXT_PUBLIC_SITE_URL ?? "https://tezam.by";
    const canonicalUrl = new URL("/partners/cabinet", siteUrl).toString();
    const defaultOg = new URL("/favicon.svg", siteUrl).toString();
    const displayName = user?.fullName?.trim() || user?.email?.split("@")[0] || "Партнёр";

    return (
        <>
            <PageHeadSync
                title={title || "Кабинет партнёра | Tezam"}
                description={description || "Реферальные ссылки, промокоды и аналитика партнёрской программы Tezam."}
                canonicalUrl={canonicalUrl}
                ogImage={process.env.NEXT_PUBLIC_OG_IMAGE_URL ?? defaultOg}
                robots="noindex,nofollow,noarchive,nosnippet"
            />
            <div className={cx("root")}>
                <header className={cx("topBar")}>
                    <div className={cx("topBarInner")}>
                        <div className={cx("brand")}>
                            <Logo />
                            <div className={cx("brandText")}>
                                <p className={cx("brandTitle")}>Кабинет партнёра</p>
                                <p className={cx("brandSubtitle")}>{displayName}</p>
                            </div>
                        </div>
                        <nav className={cx("nav")} aria-label="Навигация кабинета">
                            <Link href="/" className={cx("navLink")}>
                                На сайт
                            </Link>
                            <Link href="/cabinet" className={cx("navLink")}>
                                Клиентский кабинет
                            </Link>
                            <button type="button" className={cx("btnLogout")} onClick={() => void logout()}>
                                Выйти
                            </button>
                        </nav>
                    </div>
                </header>
                <main className={cx("body")}>{children}</main>
            </div>
        </>
    );
}
